import { throwIfAborted } from '../abort.js';
const exchanged = new WeakMap();
/** A successful check consumes the session token; its credentials belong to this provider. */
export async function readFundingConnection(provider, signal) {
    throwIfAborted(signal);
    let pending = exchanged.get(provider);
    if (!pending) {
        pending = provider.getConnection({ skipKyc: true }).then((result) => {
            if (!result.ok)
                exchanged.delete(provider);
            return result;
        }, (error) => {
            exchanged.delete(provider);
            throw error;
        });
        exchanged.set(provider, pending);
    }
    // The provider cannot abort this token exchange. Cancelling one observer must
    // neither discard its successful credentials nor start a second exchange.
    return new Promise((resolve, reject) => {
        const abort = () => {
            const error = new Error('The operation was aborted');
            error.name = 'AbortError';
            reject(error);
        };
        signal.addEventListener('abort', abort, { once: true });
        if (signal.aborted)
            abort();
        void pending.then((result) => {
            signal.removeEventListener('abort', abort);
            if (!signal.aborted)
                resolve(result);
        }, (error) => {
            signal.removeEventListener('abort', abort);
            if (!signal.aborted)
                reject(error);
        });
    });
}
